import React from "react";
import { Input, Select, Button, DatePicker } from "antd";
import { SearchOutlined, FilterOutlined, ReloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import type { ReservationStatus } from "../../../../utils/api/reservationsAPI";
import "./ReservationFilters.scss";

type Props = {
  search: string;
  onSearchChange: (v: string) => void;
  statusFilter: ReservationStatus | "all";
  onStatusChange: (v: ReservationStatus | "all") => void;
  onReset: () => void;
};

const ReservationFilters: React.FC<Props> = ({
  search,
  onSearchChange,
  statusFilter,
  onStatusChange,
  onReset,
}) => {
  const { t } = useTranslation();

  const hasFilters = search.trim() !== "" || statusFilter !== "all";

  return (
    <div className="res-filters">
      <Input
        prefix={<SearchOutlined />}
        placeholder={t("Search by name or phone...")}
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        allowClear
        size="large"
        className="res-filters__search"
      />

      <Select
        value={statusFilter}
        onChange={onStatusChange}
        size="large"
        className="res-filters__status"
        suffixIcon={<FilterOutlined />}
      >
        <Select.Option value="all">{t("All Statuses")}</Select.Option>
        <Select.Option value="pending">{t("Pending")}</Select.Option>
        <Select.Option value="confirmed">{t("Confirmed")}</Select.Option>
        <Select.Option value="seated">{t("Seated")}</Select.Option>
        <Select.Option value="completed">{t("Completed")}</Select.Option>
        <Select.Option value="cancelled">{t("Cancelled")}</Select.Option>
        <Select.Option value="no-show">{t("No Show")}</Select.Option>
      </Select>

      {hasFilters && (
        <Button
          icon={<ReloadOutlined />}
          size="large"
          onClick={onReset}
          className="res-filters__reset"
          title={t("Reset filters")}
        />
      )}
    </div>
  );
};

export default ReservationFilters;
